import { getCurrentPricelist } from '@app/ducks';
import { convertCmsProductToStandard } from '@app/logic/products';
import { CmsProductsPayload, fetchCmsProductsQuery } from '@app/services/productsRepository';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

export const CMS_PREVIEW_PRODUCTS_QUERY_KEY = 'cmsPreviewProducts';

interface Props {
  payload: Omit<CmsProductsPayload, 'search'>;
  isEnabled?: boolean;
}

export const useCmsPreviewProducts = ({ payload, isEnabled = true }: Props) => {
  const currentPricelist = useSelector(getCurrentPricelist);

  return useQuery({
    enabled: isEnabled,
    queryFn: async () => fetchCmsProductsQuery(payload),
    queryKey: [CMS_PREVIEW_PRODUCTS_QUERY_KEY, payload],
    refetchOnMount: false,
    select: data => {
      return convertCmsProductToStandard(data.products, currentPricelist);
    },
  });
};
